import { init } from "./modules/demo";

document.addEventListener("DOMContentLoaded", () => {
  init();
});
